import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReportConfigurationModel } from 'store/models/reportConfiguration';

export type DownloadItem = {
	jobId: number,
	status: 'active' | 'failed',
	progress: number,
	reportConfiguration: Pick<ReportConfigurationModel, 'id' | 'name' | 'type' | 'definition'>,
}

export type State = {
	items: DownloadItem[]
};

export const INITIAL_STATE: State = {
	items: []
};

const slice = createSlice({
	name: 'reportDownloader',
	initialState: INITIAL_STATE,
	reducers: {
		clearErrorItems: (state, action: PayloadAction<void>) => {
			state.items = state.items.filter(item => item.status === 'active');
		},
		addItem: (state, action: PayloadAction<DownloadItem>) => {
			state.items.push(action.payload);
		},
		removeItem: (state, action: PayloadAction<number>) => {
			state.items = state.items.filter(item => item.jobId !== action.payload);
		},
		setItemStatus: (state, action: PayloadAction<{ jobId: number, status: DownloadItem['status'] }>) => {
			const item = state.items.find(item => item.jobId === action.payload.jobId);
			if (item) {
				item.status = action.payload.status;
			}
		},
		setItemProgress: (state, action: PayloadAction<{ jobId: number, progress: number }>) => {
			const item = state.items.find(item => item.jobId === action.payload.jobId);
			if (item) item.progress = action.payload.progress;
		}
	}
});

export const {
	clearErrorItems,
	addItem,
	removeItem,
	setItemStatus,
	setItemProgress
} = slice.actions;

export const reducers = slice.reducer;
